import React from 'react';
import { Station } from 'api/models';
import { useFetchNowPlaying } from 'components/hooks';
import { isEmpty } from 'util/index';

interface WithPlayoutsHOCProps {
  contentTypeId: string;
  slug: string;
  items?: Array<Station>;
}

export function withPlayouts<P>(InnerComponent: React.FC<P>) {
  return (props: P): JSX.Element => {
    const { contentTypeId, slug, items } = (props as unknown) as WithPlayoutsHOCProps;

    const playouts = useFetchNowPlaying({
      contentTypeId,
      slug,
    });
    let componentItems = items;

    if (!isEmpty(playouts) && !isEmpty(items)) {
      componentItems = [];
      items.forEach((item) => {
        componentItems.push({
          ...item,
          playouts: playouts[item.slug],
        });
      });
    }

    return <InnerComponent {...props} items={componentItems} />;
  };
}

export default withPlayouts;
